var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('configured-carousel',{attrs:{"carouselItems":_vm.carouselItems}}),_c('v-container',{staticClass:"pt-1",attrs:{"fluid":"","grid-list-lg":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }